import type { PlayerReport } from "../../../api/playerReports";

export function ReportOverview({
  data,
  onFocus,
}: {
  data: PlayerReport;
  onFocus: () => void;
}) {
  const focus = data.evidence.plan[0];
  const profiles = data.evidence.profile.filter((p) =>
    p.dimensions.some((d) => d.score),
  ).length;
  return (
    <div className="report-overview" aria-label="Resumen del informe">
      <dl className="report-overview-facts">
        <div>
          <dt>Práctica registrada</dt>
          <dd>
            {data.trial_count}{" "}
            <small>{data.trial_count === 1 ? "jugada" : "jugadas"}</small>
          </dd>
          <span>
            {data.sessions.length}{" "}
            {data.sessions.length === 1 ? "sesión" : "sesiones"} ·{" "}
            {data.coaching.unresolved} sin resultado
          </span>
        </div>
        <div>
          <dt>Registro cardíaco</dt>
          <dd>
            {data.coaching.measured}
            <small> / {data.trial_count}</small>
          </dd>
          <span>jugadas con señal</span>
        </div>
        <div>
          <dt>Tu perfil</dt>
          <dd>
            {profiles}
            <small> / 2</small>
          </dd>
          <span>instrumentos con puntajes</span>
        </div>
      </dl>
      {focus && (
        <div className={`report-overview-focus signal-${focus.tone}`}>
          <span className={`report-signal-badge signal-${focus.tone}`}>
            <span className="report-signal-dot" aria-hidden="true" />
            {focus.status}
          </span>
          <h2>{focus.title}</h2>
          <p>{focus.summary}</p>
          <button type="button" onClick={onFocus}>
            Ver evidencia y qué probar →
          </button>
        </div>
      )}
    </div>
  );
}
